import React, { useState, forwardRef, useRef } from 'react'
import { useHistory } from "react-router-dom";
import httpClient from '../fetch/fetch';
import {toast} from "react-toastify"

import DatePicker from 'react-datepicker';
import DateTimePicker from 'react-datetime-picker';

import moment from 'moment/moment';
import 'moment/locale/es';

import "react-datepicker/dist/react-datepicker.css";
import { isUrlValid, slugify } from '../utils/functions';
import { useEffect } from 'react';
import Loader from './helpers/Loader';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

// import { Editor } from '@tinymce/tinymce-react';

// import { Editor } from "react-draft-wysiwyg";
// import { EditorState } from 'draft-js';
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

moment.locale('es');

function FormAddEvent({ edit = false, codigo = null }) {

    const history = useHistory();

    const [loading, setloading] = useState(edit ? true : false);

    const [sending, setsending] = useState(false);
    const [success, setsuccess] = useState(false);
    const [errors, seterrors]   = useState({});

    const editorRef = useRef(null);
    if (editorRef.current) {
        console.log(editorRef.current.getContent());
    }

    const [dataEvent, setdataEvent] = useState({

        // even_Codigo:                "",
        even_Nombre:                "",
        even_Descripcion:           "",

        even_Url:                   "",

        even_FechaInicio:           new Date(),
        even_FechaFin:              new Date(),
        even_FechaLimiteRegistro:   new Date(),

        even_AsuntoCorreo:          "",
        even_CuerpoCorreo:          "",

        even_ImagenBanner:          "",
        even_BotonAgregarCalendar:  "",
        
        even_AsistPorDia:           false,
        even_Activo:                true,
    });

    const getData = () => {
        httpClient.get(`api/evento/ObtenerEventoPorCodigo/${codigo}`)
        .then((res) => {
            console.log(res.data);

            if(res.status = 200){
                let event = res.data.configuracion;
                delete event.totalPages;
                delete event.totalRows;

                event.even_FechaInicio            = new Date(event.even_FechaInicio);
                event.even_FechaFin               = new Date(event.even_FechaFin);
                event.even_FechaLimiteRegistro    = new Date(event.even_FechaLimiteRegistro);

                setdataEvent(event);
            }

            setloading(false);

        }).catch((err) => {
            setloading(false);
        });
    }

    useEffect(() => {
        if(loading){
            getData();
        }
    }, [])
    
    const saveEvent = (e) => {
        e.preventDefault();
        let countErrors = 0;
        let dataErrors  = {};
        seterrors({});

        console.log(dataEvent);
        // console.log(moment(dataEvent.even_FechaInicio).format('YYYY-MM-DDTh:mm:ss'));

        //general

        if(dataEvent.even_Nombre === ''){
            dataErrors.even_Nombre = 'Debe ingresar un nombre';
            countErrors++;
        }

        if(dataEvent.even_Url === ''){
            dataErrors.even_Url = 'Debe asignar una url para el evento';
            countErrors++;
        }

        if(dataEvent.even_Descripcion === ''){
            dataErrors.even_Descripcion = 'Debe ingresar una descripción';
            countErrors++;
        }

        //fechas

        if(dataEvent.even_FechaInicio === '' || !dataEvent.even_FechaInicio){
            dataErrors.even_FechaInicio = 'Debe ingresar una fecha de inicio';
            countErrors++;
        }

        if(dataEvent.even_FechaFin === '' || !dataEvent.even_FechaFin){
            dataErrors.even_FechaFin = 'Debe ingresar una fecha de culminación';
            countErrors++;
        }else if(
            moment(dataEvent.even_FechaInicio).isValid() && 
            !moment(dataEvent.even_FechaFin).isSameOrAfter(moment(dataEvent.even_FechaInicio))
        ){
            dataErrors.even_FechaFin = 'La fecha de culminación debe ser posterior o igual a la de inicio';
            countErrors++;
        }


        if(dataEvent.even_FechaLimiteRegistro === '' || !dataEvent.even_FechaLimiteRegistro){
            dataErrors.even_FechaLimiteRegistro = 'Especifique la fecha limite de registro';
            countErrors++;
        }else if(
            moment(dataEvent.even_FechaLimiteRegistro).isValid() && 
            !moment(dataEvent.even_FechaLimiteRegistro).isBefore(moment(dataEvent.even_FechaFin))
        ){
            dataErrors.even_FechaLimiteRegistro = 'La fecha de limite debe ser menor a la de culminación';
            countErrors++;
        }

        //correo

        if(dataEvent.even_AsuntoCorreo === '' || !dataEvent.even_AsuntoCorreo){
            dataErrors.even_AsuntoCorreo = 'Ingrese un asunto de correo';
            countErrors++;
        }

        if(dataEvent.even_ImagenBanner === '' || !dataEvent.even_ImagenBanner){
            dataErrors.even_ImagenBanner = 'Debe asignar una imagen por url';
            countErrors++;
        }else if(!isUrlValid(dataEvent.even_ImagenBanner)){
            dataErrors.even_ImagenBanner = 'Debe ingresar una url valida';
            countErrors++;
        }
        
        if(dataEvent.even_CuerpoCorreo === '' || !dataEvent.even_CuerpoCorreo){
            dataErrors.even_CuerpoCorreo = 'Ingrese un cuerpo de correo';
            countErrors++;
        }

        if(dataEvent.even_BotonAgregarCalendar === '' || !dataEvent.even_BotonAgregarCalendar){
            dataErrors.even_BotonAgregarCalendar = 'Debe llenar este campo';
            countErrors++;
        }

        if(countErrors > 0){

            toast.error('Se han encontrado errores en el formulario');
            seterrors(dataErrors);
            return false;

        }else{
            setsending(true);

            let data = {
                ...dataEvent,

                even_Url:   slugify(dataEvent.even_Url),

                even_FechaInicio:           moment(dataEvent.even_FechaInicio).format('YYYY-MM-DDTHH:mm:ss'),
                even_FechaFin:              moment(dataEvent.even_FechaFin).format('YYYY-MM-DDTHH:mm:ss'),
                even_FechaLimiteRegistro:   moment(dataEvent.even_FechaLimiteRegistro).format('YYYY-MM-DDTHH:mm:ss')
            }

            console.log(data);
            
            {edit ? 
                httpClient.put('api/Evento/ActualizarConfiguracion', data).then((res) => {

                    console.log(res.data);
                    history.push("/listar-eventos/i0520c8a892bf11eda1eb0242ac120002");
                    toast.success('Evento actualizado satisfactoriamente');
                    setsending(false);

                }).catch((err) => {

                    console.error(err);
                    setsending(false);
                    toast.error('Ha ocurrido un error inesperado');

                })
            :
                httpClient.post('api/Evento/InsertarConfiguracion', data).then((res) => {

                    console.log(res.data);
                    history.push("/listar-eventos/i0520c8a892bf11eda1eb0242ac120002");
                    toast.success('Evento creado satisfactoriamente');
                    setsending(false);

                }).catch((err) => {

                    console.error(err);
                    setsending(false);
                    toast.error('Ha ocurrido un error inesperado');

                })
            }
        }
    }

    const changeNombre = (e, flag) => {
        const {value} = e.target;
        let newDataEvent = edit ?
        {
            ...dataEvent,
            even_Nombre:    value,
        }:
        {
            ...dataEvent,
            even_Nombre:    value,
            even_Url:       slugify(value)
        };

        setdataEvent(newDataEvent);
    }

    const handleChangeInput = (e, flag) => {
        const {value} = e.target;

        setdataEvent({
            ...dataEvent,
            [flag]: value
        });
    }

    const changeCheckbox = (checked, flag) => {
        setdataEvent({
            ...dataEvent,
            [flag]: checked
        });
    }

    const onEditorStateChange = (state, flag) => {
        setdataEvent({
            ...dataEvent,
            [flag]: state
        });
    }

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <input 
            className={(errors.hasOwnProperty('even_Url') ? "hasError " : "") + `form-control`} 
            id="even_Url" 
            name="even_Url"  
            type="text" 
            onClick={onClick}
            // defaultValue={value}
            value={value}
            ref={ref}
        />
    ));

    return (
        <div>
            
            <section className="formulario registro">
                <div className="content">
                    <div className="container">
                        <div className="row justify-content-center pt-4">
                            <div className="col-lg-6 image px-0 d-none">
                                <div className="px-5 header-data d-flex align-items-center justify-content-between">
                                    <a href="/" className="back">
                                        <img src="/images/back.svg" className='me-3' alt="" /> 
                                        Regresar
                                    </a>
                                    <div>
                                        <img src="/images/logos-formularios.svg" alt="" />
                                    </div>
                                </div>
                                <img src="/images/banner.jpg" className='img-banner' alt="" />
                            </div>
                            <div className="col-lg-7 d-flex align-items-center">
                                <div className="form-content w-100 card shadow">
                                    <div className="card-body">
                                        {!loading 
                                        ? 
                                            <>

                                                <div className="container w-100 py-4">
                                                    {edit ? 
                                                        <h2 className='title'>Editar evento</h2>
                                                    :
                                                        <h2 className='title'>Crear evento</h2>
                                                    }
                                                </div>
                                                <form onSubmit={(e) => saveEvent(e)} className='px-lg-5'>
                                                    <div className="row">

                                                        <div className="col-lg-12 col-12 col-sm-6 mb-4">
                                                            <h4 className='fw-bold h6 text-muted'>
                                                                Evento
                                                            </h4>
                                                        </div>

                                                        {/* 
                                                            <div className="col-lg-6 col-12 col-sm-6 mb-4">
                                                                <label htmlFor="even_Codigo">Código*</label>
                                                                <input 
                                                                    className={(errors.hasOwnProperty('even_Codigo') ? "hasError " : "") + `form-control`} 
                                                                    id="even_Codigo" 
                                                                    name="even_Codigo"  
                                                                    type="text" 
                                                                    defaultValue={dataEvent.even_Codigo}
                                                                    //value={ruc}
                                                                    onChange={(e) => handleChangeInput(e, 'even_Codigo')}
                                                                    // onChange={(e) => setruc(e.target.value)} 
                                                                    
                                                                />
                                                                {errors.hasOwnProperty('even_Codigo') && 
                                                                    <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                        {errors.even_Codigo ? errors.even_Codigo : ""}
                                                                    </div>
                                                                }
                                                            </div>
                                                        */}

                                                        <div className="col-lg-12 col-12 col-sm-6 mb-4">
                                                            <label htmlFor="even_Nombre">Nombre del evento*</label>
                                                            <input 
                                                                className={(errors.hasOwnProperty('even_Nombre') ? "hasError " : "") + `form-control`} 
                                                                id="even_Nombre" 
                                                                name="even_Nombre"  
                                                                type="text" 
                                                                defaultValue={dataEvent.even_Nombre}
                                                                //value={ruc}
                                                                onChange={(e) => changeNombre(e, 'even_even_NombreCodigo')}
                                                                
                                                                // onChange={(e) => setruc(e.target.value)} 
                                                                
                                                            />
                                                            {errors.hasOwnProperty('even_Nombre') && 
                                                                <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                    {errors.even_Nombre ? errors.even_Nombre : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="col-lg-12 col-12 col-sm-6 mb-4">
                                                            <label htmlFor="even_Url">Url del evento*</label>
                                                            <input 
                                                                className={(errors.hasOwnProperty('even_Url') ? "hasError " : "") + `form-control`} 
                                                                id="even_Url" 
                                                                name="even_Url"  
                                                                type="text" 
                                                                // defaultValue={dataEvent.even_Url}
                                                                value={dataEvent.even_Url}
                                                                //value={ruc}
                                                                onChange={(e) => handleChangeInput(e, 'even_Url')}
                                                                // onChange={(e) => setruc(e.target.value)} 
                                                                onBlur={(e) => {
                                                                    const samedata = dataEvent;
                                                                    if(e.target.value === ""){
                                                                        if(samedata.even_Nombre !== ""){
                                                                            setdataEvent({
                                                                                ...samedata,
                                                                                even_Url: slugify(samedata.even_Nombre)
                                                                            });
                                                                        }
                                                                    }else{
                                                                        setdataEvent({
                                                                            ...samedata,
                                                                            even_Url: slugify(e.target.value)
                                                                        });
                                                                    }
                                                                }}
                                                            />
                                                            {errors.hasOwnProperty('even_Url') && 
                                                                <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                    {errors.even_Url ? errors.even_Url : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="col-lg-12 col-12 col-sm-6 mb-4">
                                                            <label htmlFor="even_Descripcion">Descripción*</label>
                                                            <textarea 
                                                                className={(errors.hasOwnProperty('even_Descripcion') ? "hasError " : "") + `form-control`} 
                                                                id="even_Descripcion" 
                                                                name="even_Descripcion"  
                                                                type="text" 
                                                                defaultValue={dataEvent.even_Descripcion}
                                                                //value={ruc}
                                                                onChange={(e) => handleChangeInput(e, 'even_Descripcion')}
                                                                rows={3}
                                                                cols={3}
                                                                // onChange={(e) => setruc(e.target.value)} 
                                                                
                                                            />
                                                            {errors.hasOwnProperty('even_Descripcion') && 
                                                                <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                    {errors.even_Descripcion ? errors.even_Descripcion : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                        

                                                        {/* fecha */}

                                                        <div className="col-lg-12 col-12 col-sm-6 mb-4">
                                                            <h4 className='fw-bold h6 text-muted'>
                                                                Fecha
                                                            </h4>
                                                        </div>

                                                        <div className="col-lg-6 col-12 col-sm-6 mb-4">
                                                            <label htmlFor="even_Url">Inicio*</label>
                                                            <DateTimePicker 
                                                                clearIcon={null}
                                                                onChange={(date) => changeCheckbox(date, 'even_FechaInicio')} 
                                                                value={dataEvent.even_FechaInicio} 
                                                            />
                                                            {/* 
                                                            <DatePicker 
                                                                selected={dataEvent.even_FechaInicio} 
                                                                onChange={(date) => changeCheckbox(date, 'even_FechaInicio')} 
                                                                customInput={<ExampleCustomInput />}
                                                            />
                                                            */}
                                                            {errors.hasOwnProperty('even_FechaInicio') && 
                                                                <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                    {errors.even_FechaInicio ? errors.even_FechaInicio : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="col-lg-6 col-12 col-sm-6 mb-4">
                                                            <label htmlFor="even_Url">Fin*</label>
                                                            <DateTimePicker 
                                                                clearIcon={null}
                                                                value={dataEvent.even_FechaFin} 
                                                                onChange={(date) => changeCheckbox(date, 'even_FechaFin')} 
                                                            />
                                                            {/* 
                                                            <DatePicker 
                                                                selected={dataEvent.even_FechaFin} 
                                                                onChange={(date) => changeCheckbox(date, 'even_FechaFin')} 
                                                                customInput={<ExampleCustomInput />}
                                                            />
                                                            */}
                                                            {errors.hasOwnProperty('even_FechaFin') && 
                                                                <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                    {errors.even_FechaFin ? errors.even_FechaFin : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="col-lg-6 col-12 col-sm-6 mb-4">
                                                            <label htmlFor="even_Url">Limite de registro*</label>
                                                            <DateTimePicker 
                                                                clearIcon={null}
                                                                value={dataEvent.even_FechaLimiteRegistro} 
                                                                onChange={(date) => changeCheckbox(date, 'even_FechaLimiteRegistro')} 
                                                            />
                                                            {/* 
                                                            <DatePicker 
                                                                selected={dataEvent.even_FechaLimiteRegistro} 
                                                                onChange={(date) => changeCheckbox(date, 'even_FechaLimiteRegistro')} 
                                                                customInput={<ExampleCustomInput />}
                                                            />
                                                            */}
                                                            {errors.hasOwnProperty('even_FechaLimiteRegistro') && 
                                                                <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                    {errors.even_FechaLimiteRegistro ? errors.even_FechaLimiteRegistro : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="col-lg-12 col-12 col-sm-6 mb-4">
                                                            <label htmlFor="even_ImagenBanner">URL imagen encabezado evento (dimensiones de 746x200 píxeles)*</label>
                                                            <input 
                                                                className={(errors.hasOwnProperty('even_ImagenBanner') ? "hasError " : "") + `form-control`} 
                                                                id="even_ImagenBanner" 
                                                                name="even_ImagenBanner"  
                                                                type="text" 
                                                                defaultValue={dataEvent.even_ImagenBanner}
                                                                //value={ruc}
                                                                onChange={(e) => handleChangeInput(e, 'even_ImagenBanner')}
                                                                // onChange={(e) => setruc(e.target.value)} 
                                                                
                                                            />
                                                            {errors.hasOwnProperty('even_ImagenBanner') && 
                                                                <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                    {errors.even_ImagenBanner ? errors.even_ImagenBanner : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="col-lg-12 col-12 col-sm-6 mb-4">
                                                            <label htmlFor="even_BotonAgregarCalendar">HTML Botón Calendar*</label>
                                                            <textarea 
                                                                className={(errors.hasOwnProperty('even_BotonAgregarCalendar') ? "hasError " : "") + `form-control`} 
                                                                id="even_BotonAgregarCalendar" 
                                                                name="even_BotonAgregarCalendar"  
                                                                type="text" 
                                                                defaultValue={dataEvent.even_BotonAgregarCalendar}
                                                                //value={ruc}
                                                                rows={3}
                                                                onChange={(e) => handleChangeInput(e, 'even_BotonAgregarCalendar')}
                                                                // onChange={(e) => setruc(e.target.value)} 
                                                                
                                                            />
                                                            {errors.hasOwnProperty('even_BotonAgregarCalendar') && 
                                                                <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                    {errors.even_BotonAgregarCalendar ? errors.even_BotonAgregarCalendar : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                        {/* correo */}

                                                        <div className="col-lg-12 col-12 col-sm-6 mb-4">
                                                            <h4 className='fw-bold h6 text-muted'>
                                                                Correo
                                                            </h4>
                                                        </div>

                                                        <div className="col-lg-12 col-12 col-sm-6 mb-4">
                                                            <label htmlFor="even_AsuntoCorreo">Asunto*</label>
                                                            <input 
                                                                className={(errors.hasOwnProperty('even_AsuntoCorreo') ? "hasError " : "") + `form-control`} 
                                                                id="even_AsuntoCorreo" 
                                                                name="even_AsuntoCorreo"  
                                                                type="text" 
                                                                defaultValue={dataEvent.even_AsuntoCorreo}
                                                                //value={ruc}
                                                                onChange={(e) => handleChangeInput(e, 'even_AsuntoCorreo')}
                                                                // onChange={(e) => setruc(e.target.value)} 
                                                                
                                                            />
                                                            {errors.hasOwnProperty('even_AsuntoCorreo') && 
                                                                <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                    {errors.even_AsuntoCorreo ? errors.even_AsuntoCorreo : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="col-lg-12 col-12 col-sm-6 mb-4">
                                                            <label htmlFor="even_CuerpoCorreo" className='mb-3'>Cuerpo correo*</label>
                                                            <CKEditor
                                                                editor={ ClassicEditor }
                                                                data={dataEvent.even_CuerpoCorreo}
                                                                onReady={editor => {
                                                                    // You can store the "editor" and use when it is needed.
                                                                    //console.log( 'Editor is ready to use!', editor );
                                                                }}
                                                                onChange={( event, editor ) => {

                                                                    const data = editor.getData();
                                                                    onEditorStateChange(data, 'even_CuerpoCorreo');
                                                                    // console.log({ event, editor, data });

                                                                }}
                                                                onBlur={(event, editor ) => {
                                                                    //console.log( 'Blur.', editor );
                                                                }}
                                                                onFocus={(event, editor ) => {
                                                                    //console.log( 'Focus.', editor );
                                                                }}
                                                            />
                                                            
                                                            {/* 
                                                                <Editor
                                                                    onInit={(evt, editor) => editorRef.current = editor}
                                                                    initialValue="<p>This is the initial content of the editor.</p>"
                                                                    init={{
                                                                    height: 500,
                                                                    menubar: false,
                                                                    plugins: [
                                                                        'a11ychecker','advlist','advcode','advtable','autolink','checklist','export',
                                                                        'lists','link','image','charmap','preview','anchor','searchreplace','visualblocks',
                                                                        'powerpaste','fullscreen','formatpainter','insertdatetime','media','table','help','wordcount'
                                                                    ],
                                                                    toolbar: 'undo redo | casechange blocks | bold italic backcolor | ' +
                                                                    'alignleft aligncenter alignright alignjustify | ' +
                                                                    'bullist numlist checklist outdent indent | removeformat | a11ycheck code table help',
                                                                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                                                }}
                                                                />
                                                            */}
                                                            {/*
                                                            <Editor
                                                                editorState={dataEvent.even_CuerpoCorreo}
                                                                onEditorStateChange={(editorState) => onEditorStateChange(editorState, 'even_CuerpoCorreo')}
                                                                wrapperClassName="wrapper-class"
                                                                editorClassName="editor-class"
                                                                toolbarClassName="toolbar-class"
                                                                
                                                            />
                                                            */}
                                                            {/*
                                                                <textarea 
                                                                    className={(errors.hasOwnProperty('even_CuerpoCorreo') ? "hasError " : "") + `form-control`} 
                                                                    id="even_CuerpoCorreo" 
                                                                    name="even_CuerpoCorreo"  
                                                                    type="text" 
                                                                    defaultValue={dataEvent.even_CuerpoCorreo}
                                                                    //value={ruc}
                                                                    onChange={(e) => handleChangeInput(e, 'even_CuerpoCorreo')}
                                                                    rows={3}
                                                                    cols={3}
                                                                    // onChange={(e) => setruc(e.target.value)} 
                                                                    
                                                                />
                                                            */}
                                                            {errors.hasOwnProperty('even_CuerpoCorreo') && 
                                                                <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                    {errors.even_CuerpoCorreo ? errors.even_CuerpoCorreo : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                        {/* checkbox */}
                                                        {/* 
                                                        <div>
                                                            <div className="custom-control custom-checkbox pt-2">
                                                                <input 
                                                                    type="checkbox" 
                                                                    className="custom-control-input" 
                                                                    name="even_AsistPorDia" 
                                                                    id="even_AsistPorDia" 
                                                                    checked={dataEvent.even_AsistPorDia}
                                                                    onChange={() => changeCheckbox(!dataEvent.even_AsistPorDia, 'even_AsistPorDia')}
                                                                />
                                                                <label className="custom-control-label" htmlFor="even_AsistPorDia">
                                                                    Asistencia por día
                                                                </label>
                                                            </div>
                                                            {errors.hasOwnProperty('even_AsistPorDia') && 
                                                                <div className='small text-primary fw-bold pt-2 pb-3' style={{fontSize: '.6em'}}>
                                                                    {errors.even_AsistPorDia ? errors.even_AsistPorDia : ""}
                                                                </div>
                                                            }
                                                        </div>
                                                        */}

                                                        <div>
                                                            <div className="custom-control custom-checkbox pt-2">
                                                                <input 
                                                                    type="checkbox" 
                                                                    className="custom-control-input" 
                                                                    name="even_Activo" 
                                                                    id="even_Activo" 
                                                                    checked={dataEvent.even_Activo}
                                                                    onChange={() => changeCheckbox(!dataEvent.even_Activo, 'even_Activo')}
                                                                />
                                                                <label className="custom-control-label" htmlFor="even_Activo">
                                                                    Activo
                                                                </label>
                                                            </div>
                                                            {errors.hasOwnProperty('even_Activo') && 
                                                                <div className='small text-primary fw-bold pt-2 pb-3' style={{fontSize: '.6em'}}>
                                                                    {errors.even_Activo ? errors.even_Activo : ""}
                                                                </div>
                                                            }
                                                        </div>

                                                    </div>

                                                    <div className="text-center pt-4">
                                                        <button 
                                                            disabled={sending} 
                                                            type='submit' 
                                                            className='btn btn-primary px-5 fw-bold'
                                                        >
                                                            {sending ? "Enviando..." : edit ? "Editar" : "Crear"}
                                                        </button>
                                                    </div>
                                                </form>
                                            </>
                                        :
                                            <Loader />
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
        </div>
    );
}

export default FormAddEvent